module.exports = __webpack_public_path__ + "assets/woocommerce-multilingual.c9aa28b7.svg";